import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";
import Swal from "sweetalert2";
import { Spin } from "antd";

const EditHoliday = ({ editObj, fetchdata, onClose, isOpen }) => {
  const [editObjData, setEditObjData] = useState({});

  const [submitLoading, setSubmitLoading] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (editObj) {
      console.log(editObj);
      setEditObjData(editObj);
    }
  }, [editObj]);

  const handleDateChange = (e) => {
    const newDate = e.target.value;

    setEditObjData({
      ...editObjData,
      HolidayDt: newDate,
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setEditObjData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  };

  const handleUpdateHoliday = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    if (tokenData && superIdData) {
      const requestBody = {
        superid: superIdData,
        holidaydt: editObjData.HolidayDt,
        reason: editObjData.Reason,
        createdby: 1,
        optional: editObjData.Optional ? 1 : 0,
        holidayid: editObjData.holidayid,
      };

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/holidays/updateholiday`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(requestBody),
          },
        );
        const responseData = await response.json();

        if (responseData && responseData.status === true) {
          setEditObjData({
            HolidayDt: "",
            Reason: "",
            Optional: false,
            holidayid: editObjData.holidayid,
          });
          setSubmitLoading(false);

          Swal.fire({
            title: "Success",
            text: "Holiday updated successfully",
            icon: "success",
          }).then(() => {
            fetchdata();
            onClose();
          });
        } else {
          setSubmitLoading(false);
          Swal.fire({
            title: "Error",
            text: responseData.message || "Failed to update holiday.",
            icon: "error",
          });
        }
      } catch (error) {
        setSubmitLoading(false);
        console.error("Error updating holiday:", error);
        Swal.fire({
          title: "Error",
          text: "Failed to update holiday due to network or server error.",
          icon: "error",
        });
      } finally {
        setSubmitLoading(false);
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <>
      {isOpen && (
        <div>
          <style>
            {`
        @media (max-width: 576px) {
          #offcanvasRightEditHoliday {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightEditHoliday {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightEditHoliday {
            width: 27% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightEditHoliday {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightEditHoliday {
            width:12% !important;
          }
        }
        `}
          </style>
          {submitLoading && (
            <div
              className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                zIndex: 1050,
                backdropFilter: "blur(4px)",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              }}
            >
              <Spin size="large" tip="Processing..." />
            </div>
          )}

          <div className="offcanvas-backdrop fade show" onClick={onClose} />
          <div
            className="offcanvas offcanvas-end show"
            id="offcanvasRightEditHoliday"
            style={{ visibility: "visible" }}
          >
            <div className="offcanvas-header">
              <h4>Edit Holiday</h4>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={onClose}
                aria-label="Close"
              />
            </div>
            <hr />
            <div className="offcanvas-body">
              <form onSubmit={handleUpdateHoliday}>
                <div className="content">
                  <div className="row">
                    <div>
                      <label className="form-label">Reason</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editObjData?.Reason || ""}
                        onChange={(e) =>
                          setEditObjData({
                            ...editObjData,
                            Reason: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div>
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={formatDate(editObjData?.HolidayDt)}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div>
                      <label className="form-label">Optional</label>
                      <input
                        type="checkbox"
                        className="ms-3"
                        name="Optional"
                        checked={editObjData.Optional}
                        onChange={handleCheckboxChange}
                      />
                    </div>
                  </div>

                  <div className="row d-flex justify-content-end mt-3">
                    <div className="col-4 d-flex justify-content-end mr-5">
                      <button
                        type="button"
                        className="btn btn-secondary "
                        onClick={onClose}
                        aria-label="Close"
                      >
                        Cancel
                      </button>
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div className="col-2 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={submitLoading}
                      >
                        {submitLoading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

EditHoliday.propTypes = {
  editObj: PropTypes.object.isRequired,
  fetchdata: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};

export default EditHoliday;
